export enum CoverageType {
  LIFE_COVER = 'LIFE01',
  TRAUMA = 'TRAU01',
  TRAUMA_TPD = 'TPDT01',
  TRAUMA_CHILD = 'TRCH01',
  MORTGAGE_REPAYMENT = 'MORE01',
  COMPLETE_DISABLEMENT = 'CODI01',
  INCOME_COVER = 'INCO01',
  INCOME_COVER_LIFE = 'LIIN01',
  LOSS_OF_EARNING = 'LOEA01',
  REDUNDANCY_COVER = 'REDU01',
  SPECIFIC_INJURY = 'SPIN01',
  PREMIUM_COVER = 'PREM01',
}
